/* MetalWorksMorocco: long product descriptions open with "Read more".
   The full text stays in the page HTML (search engines read all of it); only the view is shortened.
   Styles live in mwm-gallery.css (.mwm-rm). */
(function () {
  function setup(desc, n) {
    if (desc.dataset.mwmRm) return;
    desc.dataset.mwmRm = '1';

    // Wrap the description text, leaving the metafield accordion (if any) outside
    const body = document.createElement('div');
    body.className = 'mwm-rm__body';
    body.id = 'MwmDesc-' + n;
    Array.from(desc.childNodes).forEach((node) => {
      if (node.nodeType === 1 && node.matches('ul.accordion')) return;
      body.appendChild(node);
    });
    desc.insertBefore(body, desc.firstChild);

    // Only shorten when there is clearly more to read; hiding a line or two is just annoying
    const fontSize = parseFloat(getComputedStyle(body).fontSize) || 16;
    if (body.scrollHeight <= fontSize * 16) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mwm-rm__toggle';
    button.setAttribute('aria-controls', body.id);
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML =
      '<span class="mwm-rm__label">Read more</span>' +
      '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    body.after(button);
    desc.classList.add('mwm-rm', 'is-collapsed');

    const label = button.querySelector('.mwm-rm__label');
    button.addEventListener('click', () => {
      const open = desc.classList.toggle('is-open');
      desc.classList.toggle('is-collapsed', !open);
      button.setAttribute('aria-expanded', String(open));
      label.textContent = open ? 'Read less' : 'Read more';
      if (!open) {
        // After closing, bring the shopper back to the start of the description if it went off screen
        const top = desc.getBoundingClientRect().top;
        if (top < 0) window.scrollBy({ top: top - 120, behavior: 'smooth' });
      }
    });
  }

  function init() {
    document.querySelectorAll('.product__description').forEach((desc, i) => setup(desc, i));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
